/**
 * Turn an `AsyncIterator` back into an `AsyncIterable`
 * - Useful to avoid infinite loops when you want to use `yield* this` in `[Symbol.asyncIterator]()`
 */
export class IteratorSequence {
    _iterator;
    constructor(iterator) {
        this._iterator = iterator;
    }
    [Symbol.asyncIterator]() {
        return this._iterator;
    }
}
